import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, map } from 'rxjs/operators';
import { CommonService } from './common.service';
import { of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient, private commonService: CommonService) { }

  // GET request
  getData(endpoint: string) {
    return this.http.get(`${this.apiUrl}/${endpoint}`, { observe: 'response' }).pipe(
      catchError(error => of(error)) // Catch errors here for consistent handling
    );
  }

  // GET request by ID
  getById(endpoint: string, id: string | number) {
    return this.http.get(`${this.apiUrl}/${endpoint}/${id}`, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return response.body;
        } else {
          throw new Error(`Unexpected status code: ${response.status}. Please contact the ATI Team for support.`);
        }
      }),
      catchError(error => this.handleError(error))
    );
  }

  // POST request
  postData(endpoint: string, payload: any) {    
    return this.http.post(`${this.apiUrl}/${endpoint}`, payload, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 201 || response.status === 202 || response.status === 200 || response.status === 204) {
          return response.body;
        } else {
          throw new Error(`Unexpected status code: ${response.status}. Please contact the ATI Team for support.`);
        }
      }),
      catchError(error => this.handleError(error)),
      finalize(() => this.commonService.stopSpinner())
    );
  }

  postDataWithContentTypeJson(endpoint: string, payload: any) {
    
    return this.http.post(`${this.apiUrl}/${endpoint}`, payload, {
      observe: 'response',
      headers: {
        'Content-Type': 'application/json',
      }
    }).pipe(
      map(response => {
        if (response.status === 201 || response.status === 202 || response.status === 200 || response.status === 204) {
          return response.body;
        } else {
          throw new Error(`Unexpected status code: ${response.status}. Please contact the ATI Team for support.`);
        }
      }),
      catchError(error => this.handleError(error)),
      
    );
  }

  // Post request by ID
  postById(endpoint: string, id: string | number, payload: any) {
    this.commonService.startSpinner();
    return this.http.post(`${this.apiUrl}/${endpoint}/${id}`, payload, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 201 || response.status === 202 || response.status === 200 || response.status === 204) {
          return response.body;
        } else {
          throw new Error(`Unexpected status code: ${response.status}. Please contact the ATI Team for support.`);
        }
      }),
      catchError(error => this.handleError(error)),
      finalize(() => this.commonService.stopSpinner())
    );
  }

  // Put request 
  putData(endpoint: string, payload: any) {
    this.commonService.startSpinner();
    return this.http.put(`${this.apiUrl}/${endpoint}`, payload, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 201 || response.status === 200 || response.status === 204) {
          return response.body;
        } else {
          throw new Error(`Unexpected status code: ${response.status}. Please contact the ATI Team for support.`);
        }
      }),
      catchError(error => this.handleError(error)),
      finalize(() => this.commonService.stopSpinner())
    );
  }

  // Put request by ID
  putById(endpoint: string, id: string | number, payload: any) {
    this.commonService.startSpinner();
    return this.http.put(`${this.apiUrl}/${endpoint}/${id}`, payload, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 201 || response.status === 200 || response.status === 204) {
          return response.body;
        } else {
          throw new Error(`Unexpected status code: ${response.status}. Please contact the ATI Team for support.`);
        }
      }),
      catchError(error => this.handleError(error)),
      finalize(() => this.commonService.stopSpinner())
    );
  }

  // Delete request by ID
  deleteById(endpoint: string, id: string | number) {
    this.commonService.startSpinner();
    return this.http.delete(`${this.apiUrl}/${endpoint}/${id}`, { observe: 'response' }).pipe(
      map(response => {
          return response; 
      }),
      catchError(error => this.handleError(error)),
      finalize(() => this.commonService.stopSpinner())
    );
  }

  // Error Handling
  handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred.';

    if (error.error) {
      if (typeof error.error === 'string') {
        errorMessage = error.error;  // If API returns a plain string
      } else if (error.error.message) {
        errorMessage = error.error.message;  // If API returns an object with a message property
      } else if (error.error.Message) {
        errorMessage = error.error.Message;  // If API returns an object with a message property
      } else if (error.error?.Errors?.length > 0) {
        errorMessage = error.error.Errors.join(', ');  // Sometimes Errors are inside an "error" property
      } else if (error.error.error) {
        errorMessage = error.error.error;  // Sometimes errors are inside an "error" property
      }
    } else if (error.message) {
      errorMessage = error.message;  // Use default message if no API message
    }

    this.commonService.openSnackBar(errorMessage, '', 'error'); // Show error in Snackbar
    return throwError(() => new Error(errorMessage));
  }


}

